import React from 'react';
import { Navigate } from 'react-router-dom';
import useSubUserAuth from '../hooks/useSubUserAuth';

/**
 * Protected route wrapper for builder screens
 * Handles authentication and sub-user access verification
 * Matches mobile app authentication flow
 */
const ProtectedBuilderRoute = ({ children }) => {
  const { isChecking, authStatus } = useSubUserAuth({
    redirectOnRevoke: '/BuilderLogin',
    showAlert: true,
    enableAutoCheck: true
  });

  // Check basic authentication
  const authToken = localStorage.getItem('authToken');
  const userRole = localStorage.getItem('userRole');

  // If no auth token, redirect to login
  if (!authToken) {
    console.log('🚫 No auth token, redirecting to login');
    return <Navigate to="/BuilderLogin" replace />;
  }

  // If not builder role (using effective role), redirect to appropriate dashboard
  if (userRole && userRole !== 'builder') {
    console.log(`🚫 User role '${userRole}' not allowed in builder area`);

    // Redirect based on user role
    switch (userRole) {
      case 'agent':
        return <Navigate to="/AgentDashboard" replace />;
      case 'agency':
        return <Navigate to="/AgencyDashboard" replace />;
      case 'admin':
        return <Navigate to="/Webadmindashboard" replace />;
      default:
        return <Navigate to="/BuilderLogin" replace />;
    }
  }

  // Show loading while checking sub-user access
  if (isChecking) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '20px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e3f2fd',
            borderTop: '4px solid #2196f3',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div style={{
            color: '#666',
            fontSize: '14px'
          }}>
            Verifying access...
          </div>
        </div>
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // If auth status is invalid, the hook will handle redirect
  if (authStatus === 'invalid') {
    return <Navigate to="/BuilderLogin" replace />;
  }

  // All checks passed, render the protected component
  return children;
};

export default ProtectedBuilderRoute;